/**
 * Where the API lives.
 * 1. VITE_API_BASE_URL, baked in at build time, wins when present.
 * 2. Otherwise, on Vammo's C4C7US layout the web app is served from `issues.<domain>` and the API
 *    from `services.<domain>/ms-issue-tracker` (ADR-0009), so the URL is derived from the host.
 *    This keeps the static bundle correct even if the build argument does not reach the build.
 * 3. Otherwise (local development, the Caddy gateway) the API is on the same origin.
 */
const API_PREFIX_PATH = '/ms-issue-tracker';

function resolveApiBase(): string {
  const configured = ((import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '').trim().replace(/\/$/, '');
  if (configured) return configured;
  if (typeof window === 'undefined') return '';
  const match = /^issues\.(.+)$/.exec(window.location.hostname);
  return match ? `${window.location.protocol}//services.${match[1]}${API_PREFIX_PATH}` : '';
}

export const API_BASE = resolveApiBase();

/** Cross-origin calls must carry the session cookie explicitly. */
export const fetchCredentials: RequestCredentials = API_BASE ? 'include' : 'same-origin';

/** Absolute URL for an API path such as /auth/login or a server-provided /api/v1/... link. */
export function apiUrl(path: string): string {
  if (/^https?:\/\//.test(path)) return path;
  return `${API_BASE}${path}`;
}
